import { makeRequest, thunkify } from '@/shared/services/http';
import { AddressRequest } from './models/request';
import { AddressResponse } from './models/response';
import { AllergyDTO, ConditionDTO } from './models/dtos';
import { ICustomersGetResponse, ICustomersUserProfileResponse } from '@/shared/endpoints/customers/models/response';

export class OnboardingController {
    // POST_ADDRESS_VALIDATE_URL: 'addresses/validate',
    static validateAddress = (params: AddressRequest) => {
        // return makeRequest<AddressResponse, AddressRequest>('post', 'addresses', 'validate', params);
        return makeRequest<AddressResponse, AddressRequest>('post', 'addresses', 'validate', params, {
            headers: { version: 'v3'}
        });
    };
    // SEARCH_CONDITION: 'icdcodes/search/conditions',
    static searchConditions = (params: any, signal: AbortSignal) =>
        makeRequest<Array<ConditionDTO>, any>('get', 'icdcodes', 'search/conditions', { params, signal });
    // SEARCH_ALLERGIES_URL: 'allergies/search',
    static searchAllergies = (params: any, signal: AbortSignal) =>
        makeRequest<Array<AllergyDTO>, any>('get', 'allergies', 'search', { params, signal });

    // POST_CUSTOMER_ADDRESS: 'customers/addresses',
    static addUserAddress = thunkify<ICustomersGetResponse, any>('post', 'customers', 'addresses', async (request, data) => {
        const res = await request(data, {});
        return res;
    });

    static updateUserAddress = thunkify<ICustomersGetResponse, any>('put', 'customers', 'addresses/:id', async (request, data) => {
        const res = await request(data, {
            urlParams: { id: data.id }
        });
        return res;
    });

    // POST_CUSTOMER_ADDRESS: 'customers/addresses',
    static deleteUserAddress = thunkify<any, any>('delete', 'customers', 'addresses/:id', async (request, data) => {
        const res = await request({
            urlParams: { id: data.id },
            params: { version: data.ver }
        });
        return res;
    });

    static createUserProfile = thunkify<any, any>('post', 'customers', '', async (request, data) => {
        const res = await request(data, {});
        return res;
    });

    static updateUserProfile = thunkify<Partial<ICustomersUserProfileResponse>, ICustomersUserProfileResponse>(
        'put',
        'customers',
        '',
        (request, data) => {
            return request(data, {
                urlParams: { id: data.id }
            });
        }
    );
}
